export enum ReportType {
  AGGREGERT_MENGDEOVERSIKT_VEG = 9000,
  AGGREGERT_MENGDEOVERSIKT_VEGKATEGORI = 9100,
  DETALJERT_MENGDEOVERSIKT = 12000,
  DETALJERT_MENGDEOVERSIKT_ENKELTOBJEKT = 10000,
  GEOPACKAGE = 11000,
  OVERLAPP = 7246,
  RELASJON_EXCEL = 9373,
  RELASJON_GEOPACKAGE = 10705,
  SKREDSIKRING = 10053,
  TILSTAND = 13000,
  VEGNETT = 8000,
  TUNNEL_SPEED_REPORT = 12626,
  OBJECT_HOLE = 10405,
}
